<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0>
      <v-layout row wrap>
        <v-flex xs12 v-if="admin">
          <v-flex xs12 mb-3>
            <h1 class="max" v-if="state == 'initial'">Cadastrar Parceiro</h1>
            <h1 class="max" v-if="state == 'processing'">Aguarde</h1>
            <h1 class="max" v-if="state == 'created'">Parceiro Cadastrado</h1>
          </v-flex>
          <v-flex v-if="state == 'initial' || state == 'processing'" xs12>
            <v-stepper
              v-model="step"
              class="mb-3 br-10 font-paralucent"
              color="white"
            >
              <v-stepper-header ref="formHeader">
                <v-stepper-step editable step="1"> Dados gerais </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step editable step="2" @click="goToStepNextStep(2)"> Taxas </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step editable step="3" @click="goToStepNextStep(3)">
                  FacilitaPay - Contas bancárias
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step editable step="4" @click="goToStepNextStep(4)">
                  Parceiro - Contas Bancárias
                </v-stepper-step>
              </v-stepper-header>
              <v-stepper-content step="1">
                <AdminPartnerCreateForm :partner="partner" :company="company" :user="user"/>
                <v-flex class="xs12 lg12 justify-flex-end">
                  <v-btn
                    class="font-weight-black btn-bg-color flex-1 text-color-white"
                    @click="goToStepNextStep(2)"
                    >Prosseguir</v-btn
                  >
                </v-flex>
              </v-stepper-content>
              <v-stepper-content step="2">
                <partner-form :record="this.partner_taxes" :createNewPartner="true" :set_default_iof_tax="true" @getPartnerConfigAndTaxes="getPartnerConfigAndTaxes"/>
                <v-flex class="xs12 lg12 justify-flex-end">
                  <v-btn
                    flat
                    class="font-weight-black flex-1 secondary-btn-bg-color text-color-white"
                    @click="step = 1"
                  >
                    Voltar
                  </v-btn>
                  <v-btn class="font-weight-black flex-1 btn-bg-color text-color-white" @click="step=3">
                    Prosseguir
                  </v-btn>
                </v-flex>
              </v-stepper-content>
              <v-stepper-content step="3">
                <v-container>
                  <v-flex xs12 display-1>
                    Facilita Pay - Contas bancárias
                  </v-flex>
                  <ExternalBankAccounts
                    :bank_accounts="this.facilita_bank_accounts_list"
                    :show_partner_facilita_bank_accounts="true"
                    :onboarding="true"
                    @onAccountCreate="onAccountCreate"
                    @onAccountUpdate="onAccountUpdate"
                    @onAccountDelete="onAccountDelete"
                  />
                  <v-flex xs12 display-1>
                    Facilita Pay - Contas bancárias compartilhadas
                  </v-flex>
                  <ExternalBankAccounts
                    :bank_accounts="this.facilita_shared_bank_accounts_list"
                    :show_partner_facilita_bank_accounts="true"
                    :display_action_columns="false"
                    :select_shared_account="true"
                    :show_add_button="false"
                    :onboarding="true"
                    @onToggleSelected="onToggleSelected"
                  />
                  <v-flex class="xs12 lg12 justify-flex-end">
                    <v-btn
                      flat
                      class="font-weight-black flex-1 secondary-btn-bg-color text-color-white"
                      @click="step = 2"
                    >
                      Voltar
                    </v-btn>
                    <v-btn class="font-weight-black flex-1 btn-bg-color text-color-white" @click="step=4">
                      Prosseguir
                    </v-btn>
                  </v-flex>
                </v-container>
              </v-stepper-content>
              <v-stepper-content step="4">
                <v-container>
                  <v-flex class="xs12 lg12 title-form display-1">
                    Parceiro - Contas bancárias
                  </v-flex>
                  <ExternalBankAccounts
                    :bank_accounts="this.partner_bank_accounts_list"
                    :show_partner_external_bank_accounts="true"
                    :onboarding="true"
                    @onAccountCreate="onAccountCreate"
                    @onAccountUpdate="onAccountUpdate"
                    @onAccountDelete="onAccountDelete"
                  />
                  <v-flex class="xs12 lg12 justify-flex-end">
                    <v-btn
                      flat
                      class="font-weight-black flex-1 secondary-btn-bg-color text-color-white"
                      @click="step = 3"
                    >
                      Voltar
                    </v-btn>
                    <v-btn
                      class="font-weight-black flex-1 btn-bg-color text-color-white"
                      @click="createPartner()"
                    >
                      Cadastrar
                    </v-btn>
                  </v-flex>
                </v-container>
              </v-stepper-content>
            </v-stepper>
          </v-flex>
          <v-flex v-else>
            <AdminPartnerCreatedScreen 
              :success_response="success_response"
              :to="partner.protonmail"
              :separate_internal_bank_account_flows="separate_internal_bank_account_flows_boolean"
              @resetForm="resetForm"/>
          </v-flex>
        </v-flex>
        <v-flex v-else>
          <h1 >Não foi possível carregar a página. Você não foi autorizado.</h1>
        </v-flex>
      </v-layout>
    </v-container>
      <error-dialog 
        :required_empty_fields="required_empty_fields"
        :errors="errors"
        :show_error_dialog="show_error_dialog"
        @closeDialog="closeDialog"
      />
  </layout>
</template>

<script>

  import AdminPartnerConfigForm from "./AdminPartnerConfigForm.vue"
  import AdminPartnerCreateErrorMessageDialog from "./AdminPartnerCreateErrorMessageDialog.vue"
  import AdminPartnerCreateForm from "./AdminPartnerCreateForm"
  import AdminPartnerCreatedScreen from "./AdminPartnerCreatedScreen"
  import ExternalBankAccounts from "./ExternalBankAccounts"
  import LeftBarLayout from "./layouts/LeftBarLayout"
  import { BankAccountsApi } from '@/shared/BankAccountsApi'

  export default {
    name: 'AdminPartnerCreate',
    components: {
      'partner-form': AdminPartnerConfigForm,
      'error-dialog': AdminPartnerCreateErrorMessageDialog,
      AdminPartnerCreateForm,
      AdminPartnerCreatedScreen,
      ExternalBankAccounts,
      layout: LeftBarLayout
    },
    data: () => {
      return {
        admin: false,
        state: 'initial',
        errors: {},
        step: 1,
        show_error_dialog: false,
        show_success_dialog: false,
        required_empty_fields: [],
        company: {
          social_name: '',
          company_name: '',
          document_type: 'tax_id',
          document_number: '',
          fiscal_country: ''
        },
        partner: {
          internal_bank_account_currencies: ["BRL", "USD"],
          separate_internal_bank_account_flows: "true",
          protonmail: ''
        },
        user: {
          name: '',
          username: '',
          permissions: ["tokens-create", "tokens-cancel", "users-list", "users-create", "users-disable", "users-enable", "transactions-create-receive", "transactions-create-pay", "transactions-create-deposit", "transactions-create-withdrawal_internal", "transactions-create-exchange_internal"],
          status: "active"
        },
        facilita_bank_accounts_list: [],
        facilita_shared_bank_accounts_list: [],
        partner_bank_accounts_list: [],
        partner_taxes: {
          company_taxes: true
        },
        company_taxes: {},
        partner_config: {},
        success_response: {},
        separate_internal_bank_account_flows_boolean: false
      }
    },
    mounted() {
      this.admin = this.$cookies.isKey('admin') && this.$cookies.get('admin') === 'true' && this.$root.userAllowedTo('create_user_credentials')
      this.loadSharedBankAccounts()
    },
    methods: {
      onAccountDelete(bank_account, is_facilita_account) {
        if(is_facilita_account) {
          let index = this.getIndexFromList(bank_account, this.facilita_bank_accounts_list)
          if(index!=null) {
            this.facilita_bank_accounts_list.splice(index, 1)
          }
          if (bank_account.selected) {
            this.toggleSelected(bank_account)
          }
        } else {
          let index = this.getIndexFromList(bank_account, this.partner_bank_accounts_list)
          if(index!=null) {
            this.partner_bank_accounts_list.splice(index, 1)
          }
        }
      },
      onAccountCreate(bank_account, is_facilita_account) {
        if(is_facilita_account) {
          if (!bank_account.id) {
            let id = this.facilita_bank_accounts_list.length + 1
            bank_account.id = id
          }
          this.facilita_bank_accounts_list.push({...bank_account})
        } else {
          let id = this.partner_bank_accounts_list.length + 1
          bank_account.id = id
          this.partner_bank_accounts_list.push({...bank_account})
        }
      },
      onAccountUpdate(bank_account, is_facilita_account) {
        if(is_facilita_account) {
          let index = this.getIndexFromList(bank_account, this.facilita_bank_accounts_list)
          this.facilita_bank_accounts_list.splice(index, 1, bank_account)
        } else {
          let index = this.getIndexFromList(bank_account, this.partner_bank_accounts_list)
          this.partner_bank_accounts_list.splice(index, 1, bank_account)
        }
      },
      getIndexFromList(elem, list) {
        for(let i=0; i<list.length; i++) {
          if(list[i].id == elem.id){
            return i
          }
        }
        return null
      },
      createPartner() {
        if (this.state !== 'initial') return

        if(!this.validate_required_fields()){
          this.step=1
          this.show_error_dialog = true 
        } else {
          this.state = 'processing'
          let payload = this.buildPayload()

          let successCallback = (response) => {
            if (response.body.errors) {
              this.errors = response.body.errors
              this.show_error_dialog = true
              this.state = 'initial'
            } else {
              this.separate_internal_bank_account_flows_boolean = this.partner.separate_internal_bank_account_flows == "true"
              this.success_response = response.body.data
              this.state = 'created'
            }
          }

          let errorCallback = (response) => {
            if (response.body.errors) {
              this.errors = response.body.errors
              this.show_error_dialog = true
            }
            this.state = 'initial'
          }

          let token = this.$cookies.get('api_token')
          this.$http.post(this.$root.urls.admin__onboard, payload, { headers: { Authorization: `Bearer ${token}` } }).then(successCallback, errorCallback)
        }
      },
      validate_required_fields(){
        this.required_empty_fields = this.get_empty_required_fields()
        if(this.required_empty_fields.length != 0) {
          return false
        }
        return true
      },
      get_empty_required_fields() {
        let empty_fields_list = []
        if(this.company.social_name.trim() == '') empty_fields_list.push('Nome da empresa')
        if(this.company.document_number.trim() == '') empty_fields_list.push('Número do documento')
        if(this.user.name.trim() == '') empty_fields_list.push('Nome social do usuário')
        if(this.user.username.trim() == '') empty_fields_list.push('Username do usuário')
        if(this.partner.internal_bank_account_currencies.length == 0) empty_fields_list.push('Moedas das contas bancárias internas')
        if(this.partner.protonmail.trim() == '') empty_fields_list.push('Proton Mail')
        if(this.company.fiscal_country.trim() == '') empty_fields_list.push('País fiscal da empresa')
        return empty_fields_list
      },
      buildPayload() {
        this.user.username = this.user.username.toLowerCase()
        let payload = {
          onboard_params: {
            user: this.user,
            internal_bank_account_currencies: this.partner.internal_bank_account_currencies,
            separate_internal_bank_account_flows: this.partner.separate_internal_bank_account_flows == "true",
            company: this.company,
            facilita_bank_accounts: this.facilita_bank_accounts_list,
            facilita_shared_bank_accounts: this.facilita_shared_bank_accounts_list,
            partner_bank_accounts: this.partner_bank_accounts_list,
            partner_config: this.partner_config,
            protonmail: this.partner.protonmail.toLowerCase(),
            taxes: this.company_taxes
          } 
        }
        return payload
      },
      closeDialog(step){
        this.required_empty_fields = []
        this.error_message = ''
        this.show_error_dialog = false
        this.step=step
      },
      closeSuccessDialog(){
      },
      getPartnerConfigAndTaxes(partner_config, company_taxes) {
        this.company_taxes = company_taxes
        this.partner_config = partner_config
      },
      goToStepNextStep(next_step){
        this.step=next_step
      },
      resetForm(){
        this.state =  'initial'
        this.errors =  {}
        this.success_response = {}
        this.partner =  {
          internal_bank_account_currencies: ["BRL", "USD"],
          separate_internal_bank_account_flows: "true",
          protonmail: ''
        }
        this.company = {
          social_name: '',
          company_name: '',
          document_type: 'tax_id',
          document_number: '',
          fiscal_country: ''
        }
        this.step = 1
        this.facilita_bank_accounts_list = []
        this.facilita_shared_bank_accounts_list = []
        this.partner_bank_accounts_list = []
        this.partner_taxes = {
          company_taxes: true
        }
        this.company_taxes = {}
        this.partner_config = {}
        this.user = {
          name: '',
          username: '',
          permissions: ["tokens-create", "tokens-cancel", "users-list", "users-create", "users-disable", "users-enable", "transactions-create-receive", "transactions-create-pay", "transactions-create-deposit", "transactions-create-withdrawal_internal", "transactions-create-exchange_internal"],
          status: "active"
        }
      },
      getSeparateInternalBankAccountFlows()  {
        return partner.separate_internal_bank_account_flows == "true"
      },
      loadSharedBankAccounts() {
        let successCallback = (response) => {
          if (response.body.data) {
            this.facilita_shared_bank_accounts_list = this.facilita_shared_bank_accounts_list.concat(response.body.data)
          }
        }

        let errorCallback = (response) => {
          if (response.status === 401) {
            console.log('loadSharedBankAccounts not_authorized')
            return
          } else {
            console.log('loadSharedBankAccounts errorCallback', response)
            return
          }
        }

        BankAccountsApi.onlyGet(this, this.$root.urls.bank_accounts, successCallback, errorCallback, { not_exclusive: true });
      },
      toggleSelected(bank_account) {
        bank_account.selected = bank_account.selected ? false : true
        let index = this.getIndexFromList(bank_account, this.facilita_shared_bank_accounts_list)
        this.facilita_shared_bank_accounts_list.splice(index, 1, bank_account)
      },
      onToggleSelected(bank_account) {
        this.toggleSelected(bank_account)
        if (bank_account.selected) {
          this.onAccountCreate(bank_account, true)
        } else {
          this.onAccountDelete(bank_account, true)
        }
      }
    },
    metaInfo: {
      title: "Facilita Pay"
    }
  }
</script>

<style>
.disable-events {
  pointer-events: none;
}

.btn-style,
.btn-style--secondary {
  height: 56px;
}
.btn-bg-red {
  background-color: var(--light-red-color) !important;
  color: white !important;
}
.btn-style {
  background-color: var(--primary-button-background-color) !important;
}
.btn-style--secondary {
  background-color: var(--secondary-button-background-color) !important;
}
.v-stepper__step >>> span.primary {
  background-color: var(--background-color) !important;
}
li.documentList {
  color: #333;
  cursor: pointer;
}
.title-form {
  color: #44517b !important;
}
.text-color-white,
.dark-mode .text-color-white {
  color: white !important;
}

.br-10 {
  border-radius: 10px;
}

.font-paralucent {
  font-family: paralucent !important;
}
.cursor-type {
  cursor: default;
}

.align-center {
  align-items: center;
}

.justify-flex-end {
  display: flex;
  justify-items: flex-end;
}

.p-relative {
  position: relative;
}

.width-position {
  width: 270px;
  position: absolute;
  top: 30px;
  left: 0px;
}
.flex-align {
  display: flex;
  align-items: baseline;
}
.flex-1 {
  flex: 1;
}
.flex-2 {
  flex: 2;
}
.flex-3 {
  flex: 3;
}
.btn-bg-color {
  background-color: var(--secondary-button-background-color) !important;
}
.flex-space-between {
  display: flex;
  justify-content: space-between;
}
.secondary-btn-bg-color {
  color: var(--background-color) !important;
}
.display-flex-baseline {
  display: flex;
  align-items: baseline;
}
.display-flex-baseline-start {
  display: flex;
  align-items: baseline;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.text-color-gray {
  color: gray !important;
}

.text-color-red {
  color: rgb(255, 55, 55) !important;
}
.dark-mode .upload-btn-bg-color {
  color: white !important;
}
.upload-btn-bg-color {
  color: var(--background-color) !important;
}
</style>



// WEBPACK FOOTER //
// src/AdminPartnerCreate.vue